export default (restServer) => ({
    GET_WATCHLIST_LIST: () => restServer("/internal/api/oms/v1/watchlist"),
    GET_WATCHLIST_BY_ID: (watchLIstId) => restServer(`/internal/api/oms/v1/watchlist/${watchLIstId}`),
    SAVE_WATCHLIST: (payload) => {
        return restServer("/internal/api/oms/v1/watchlist/save", {
            body: payload,
        });
    },
    DELETE_WATCHLIST_ITEMS: (watchlistId, itemIds) => {
        return restServer("/internal/api/oms/v1/watchlist/delete", {
            body: { watchlistId, itemIds },
        });
    },
    DELETE_WATCHLIST: (watchlistId) => restServer(`/internal/api/oms/v1/watchlist/delete/${watchlistId}`),
});
